'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _entry = require('react-pdf/dist/entry.noworker');

var _reactFa = require('react-fa');

var _components = require('../../styled/components');

var _Close = require('../Icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _styled = require('../PdfPreviewPopup/styled');

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PdfPreview =
/*#__PURE__*/
function (_react$Component) {
  _inherits(PdfPreview, _react$Component);

  function PdfPreview() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PdfPreview);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PdfPreview)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      page: 1,
      numPages: 1,
      width: _this.props.width || 800
    }, _this.containerRef = _react2.default.createRef(), _this.onLoad = function (_ref) {
      var numPages = _ref.numPages;

      _this.setState(function () {
        return {
          numPages: numPages
        };
      });
    }, _this.onNextPage = function () {
      var numPages = _this.state.numPages;

      _this.setState(function (prevState) {
        return {
          page: prevState.page >= numPages ? numPages : prevState.page + 1
        };
      });
    }, _this.onPrevPage = function () {
      _this.setState(function (prevState) {
        return {
          page: prevState.page <= 1 ? 1 : prevState.page - 1
        };
      });
    }, _temp));
  }

  _createClass(PdfPreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState(function (prevState) {
        return {
          width: _this2.containerRef.current ? _this2.containerRef.current.offsetWidth : prevState.width
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          page = _this$state.page,
          numPages = _this$state.numPages,
          width = _this$state.width;
      var _this$props = this.props,
          link = _this$props.link,
          closePopup = _this$props.closePopup,
          _this$props$hasDownlo = _this$props.hasDownloading,
          hasDownloading = _this$props$hasDownlo === void 0 ? true : _this$props$hasDownlo,
          spPlatformConfig = _this$props.spPlatformConfig;
      return _react2.default.createElement('div', {
        className: 'pdf-preview-container'
      }, _react2.default.createElement('div', {
        className: 'react-pdf',
        ref: this.containerRef
      }, _react2.default.createElement('div', null, _react2.default.createElement(_components.ThemedButton, {
        disabled: page === 1,
        type: 'primary',
        onClick: this.onPrevPage
      }, 'Previous'), numPages ? _react2.default.createElement('span', {
        style: {
          margin: '0 16px'
        }
      }, "".concat(page, " / ").concat(numPages)) : null, _react2.default.createElement(_components.ThemedButton, {
        disabled: page === numPages,
        type: 'primary',
        onClick: this.onNextPage
      }, 'Next')), hasDownloading && _react2.default.createElement('div', {
        style: {
          position: 'absolute',
          right: 50,
          height: '18px',
          width: '12px'
        }
      }, _react2.default.createElement('a', {
        target: '_blank',
        className: 'document-list__icon',
        download: link,
        href: link,
        name: 'download'
      }, _react2.default.createElement(_components.ThemedIcon, {
        name: 'download'
      }))), spPlatformConfig ? _react2.default.createElement(_styled2.default.CloseBtnWrapper, {
        onClick: closePopup
      }, _react2.default.createElement(_Close2.default, {
        height: '12px',
        width: '12px'
      })) : null), _react2.default.createElement(_entry.Document, {
        file: link,
        onLoadSuccess: this.onLoad
      }, _react2.default.createElement(_entry.Page, {
        pageNumber: page,
        width: width
      })));
    }
  }]);

  return PdfPreview;
}(_react.Component);

exports.default = PdfPreview;